export default "__VITE_ASSET__C9V2kg01__"